import { useCallback, useSyncExternalStore } from 'react'
import { getConsentState, setConsent, subscribeConsent } from '../utils/cookieConsent.ts'

export const useCookieConsent = () => {
    const state = useSyncExternalStore(subscribeConsent, getConsentState)

    const acceptAll = useCallback(() => setConsent({ analytics: true }), [])
    const rejectAll = useCallback(() => setConsent({ analytics: false }), [])
    const save = useCallback((analytics: boolean) => setConsent({ analytics }), [])

    return { ...state, acceptAll, rejectAll, save }
}
